import React, { useState } from 'react';
import { Box, SxProps, Typography, useTheme } from '@mui/material';
import { SectionLink } from 'entities/section/model/sectionModel';
import IconSectionLink from 'shared/icons/iconSectionLink';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import { makeTransition } from 'shared/lib/utils/utils';
import { undefinedOnTouchDevice } from 'shared/lib/utils/globalUtils';

export default function SectionWidgetLink({
  sx,
  setIsHover,
  linkData,
}: {
  sx?: SxProps;
  setIsHover: (val: boolean) => void;
  linkData: SectionLink;
}) {
  const [isLinkHover, setIsLinkHover] = useState(false);
  const theme = useTheme();
  const { isLessLaptop, isLessDesktopSmall } = useBooleanScreens();
  const linkColor =
    isLinkHover && !isLessLaptop
      ? theme.palette.primary.main
      : theme.palette.text.primary;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: isLessLaptop ? '4px' : '6px',
        padding: isLessLaptop ? '0 4px 0 6px' : '0 8px 0 12px',
        ...sx,
      }}
      component="a"
      href={linkData?.src}
      target="_blank"
      onMouseEnter={undefinedOnTouchDevice(() => {
        setIsHover(false);
        setIsLinkHover(true);
      })}
      onMouseLeave={undefinedOnTouchDevice(() => {
        setIsHover(true);
        setIsLinkHover(false);
      })}
      onClick={(e) => {
        e.stopPropagation();
      }}
      data-testid={'section-link'}
    >
      <IconSectionLink
        extColor={linkColor}
        isAutoscallable={false}
        linkType={linkData?.icon}
        sizeKey={isLessDesktopSmall ? '16x16' : '20x20'}
        style={{ transition: makeTransition(['fill']) }}
      ></IconSectionLink>
      <Typography
        variant={isLessLaptop ? 'f12bfixed' : 'f16bfixed'}
        color={linkColor}
      >
        {linkData?.text}
      </Typography>
    </Box>
  );
}
